<div
  *ngIf="isOpen"
  class="fixed bottom-3 left-3 right-3 z-[9000] max-w-[100vw] sm:bottom-4
    sm:left-4 sm:right-auto sm:w-[380px] sm:max-w-[calc(100vw-2rem)]"
>
  <!-- Mobile-only: X button outside card, top-right edge -->
  <button
    type="button"
    (click)="dismiss()"
    class="absolute -top-1.5 -right-0.5 z-10 inline-flex h-6 w-6 items-center
      justify-center rounded-full border border-gray-200 bg-white shadow-md
      dark:border-gray-600 dark:bg-gray-800 text-gray-600 dark:text-gray-300
      hover:bg-gray-50 dark:hover:bg-gray-700 sm:hidden"
    aria-label="Close"
  >
    <svg class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
    </svg>
  </button>

  <div
    class="relative flex max-w-full flex-row overflow-hidden bg-white
      dark:bg-gray-900 shadow-2xl rounded-2xl border border-gray-200
      dark:border-gray-700 sm:flex-col sm:rounded-[26px]"
    role="region"
    aria-label="New profile feature"
  >
    <!-- Mobile-only: New badge (temporarily hidden – reusing content badge) -->
    <div class="absolute left-1 top-1 z-10 hidden">
      <span
        class="inline-flex items-center gap-1 rounded-full px-2 py-0.5
          text-[9px] font-semibold tracking-widest uppercase
          text-green-800 dark:text-green-300 bg-green-100 dark:bg-green-900/40
          ring-1 ring-green-200/50 dark:ring-green-700/50"
      >
        <span class="h-1 w-1 shrink-0 rounded-full bg-green-600" aria-hidden="true"></span>
        New
      </span>
    </div>

    <!-- Mobile: small image strip. Desktop: image on top -->
    <div
      class="relative hidden h-auto w-[88px] shrink-0 overflow-hidden
        sm:block sm:w-full sm:rounded-t-[26px] sm:bg-gray-100 dark:sm:bg-gray-800"
    >
      <img
        src="/assets/images/desktop-profile-banner.png"
        alt=""
        class="hidden h-full w-full object-cover object-top sm:block sm:h-auto
          sm:object-contain"
      />
      <!-- Close over image (desktop) -->
      <div
        class="absolute inset-x-0 top-0 hidden justify-end p-3 sm:flex"
      >
        <button
          type="button"
          (click)="dismiss()"
          class="inline-flex h-10 w-10 items-center justify-center rounded-full
            bg-black/40 hover:bg-black/60 text-white backdrop-blur
            transition-colors"
          aria-label="Close"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
      <!-- Desktop-only: short gradient fade into card background -->
      <div
        class="absolute bottom-0 left-0 right-0 hidden h-10 pointer-events-none
          bg-gradient-to-t from-white to-transparent
          dark:from-gray-900 dark:to-transparent sm:block"
      ></div>
    </div>

    <!-- Mobile-only: left image strip (full height of card) -->
    <div
      class="relative flex min-h-0 w-[88px] shrink-0 self-stretch overflow-hidden
        rounded-l-2xl sm:hidden"
    >
      <img
        src="/assets/images/mobile-profile-banner.png"
        alt=""
        class="h-full w-full object-cover object-left"
      />
    </div>

    <!-- Content: right on mobile, below image on desktop -->
    <div class="relative flex min-w-0 flex-1 flex-col overflow-hidden px-3
      pt-3 pb-3.5 sm:px-5 sm:pt-5 sm:pb-6">
      <div class="mb-1.5 inline-flex items-center gap-2 sm:mb-3">
        <span
          class="inline-flex items-center gap-1 rounded-full px-2 py-0.5
            text-[9px] font-semibold tracking-widest uppercase
            text-green-800 dark:text-green-300 bg-green-100 dark:bg-green-900/40
            ring-1 ring-green-200/50 dark:ring-green-700/50
            sm:gap-1.5 sm:px-2.5 sm:py-1 sm:text-[10px] sm:ring-0"
        >
          <span class="h-1 w-1 shrink-0 rounded-full bg-green-600 sm:h-1.5 sm:w-1.5" aria-hidden="true"></span>
          New
        </span>
      </div>
      <h3 class="text-sm font-extrabold leading-tight text-gray-900 dark:text-white pr-8 sm:pr-0 sm:text-lg">
        Build your public profile in minutes
      </h3>
      <p class="mt-1.5 text-xs text-gray-600 dark:text-gray-300 sm:text-sm">
        Add your work, highlight your strengths, and share a link recruiters can actually skim.
      </p>

      <div class="mt-2.5 flex min-w-0 flex-nowrap gap-2 sm:mt-6 sm:gap-3">
        <button
          type="button"
          (click)="learnMore()"
          class="btn-primary btn-sm min-w-0 shrink max-sm:min-h-0 max-sm:py-1.5
            max-sm:px-2.5 max-sm:text-[11px] max-sm:font-semibold"
        >
          Learn more
          <svg class="ml-1 h-3 w-3 max-sm:ml-1 sm:ml-2 sm:h-4 sm:w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M3 10a1 1 0 011-1h9.586L10.293 5.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 11-1.414-1.414L13.586 11H4a1 1 0 01-1-1z" clip-rule="evenodd" />
          </svg>
        </button>
        <button
          type="button"
          (click)="viewExample()"
          class="btn-secondary btn-sm min-w-0 shrink max-sm:min-h-0
            max-sm:py-1.5 max-sm:px-2.5 max-sm:text-[11px] max-sm:font-semibold"
        >
          View example
        </button>
      </div>
    </div>
  </div>
</div>
